import { useCallback, useMemo } from 'react'
import type { IMoreMenuItem } from '@sales-center/components'
import { useActivityTypesContext } from '../../../../context'
import {
  openDeleteDialogActionCreator,
  updateActivityTypeActionCreator,
} from '../../../../state'

type Props = {
  id: string
}

export function useMoreOptions(props: Props) {
  const { id } = props
  const [{ activityTypes }, dispatch] = useActivityTypesContext()
  const activityType = useMemo(
    () => activityTypes.find((activity) => activity.id === id),
    [activityTypes, id],
  )

  const onEditClick = useCallback(() => {
    dispatch(updateActivityTypeActionCreator(activityType))
  }, [activityType, dispatch])

  const onDeleteClick = useCallback(async () => {
    dispatch(openDeleteDialogActionCreator(id))
  }, [dispatch, id])

  return useMemo<IMoreMenuItem[]>(
    () => [
      { label: 'Edit', onClick: onEditClick },
      { label: 'Delete', onClick: onDeleteClick },
    ],
    [onEditClick, onDeleteClick],
  )
}
